import {Locales} from '@netx/core-next/locales/utils/Locales';
import {CartAssetActionLabel} from '@netx/core-cart-asset/locales';

export const AssetMessage = Locales((i18n) => ({
	CONFIRM_DELETE: i18n('i18n.deleteAssetMessage'),
	NOT_FOUND: i18n('i18n.assetNotFound'),
}));

export const AssetActionLabel = Locales((i18n) => ({
	...CartAssetActionLabel,
	CHECKIN: i18n('i18n.checkInNewVersion'),
	CHECKOUT: i18n('i18n.checkOutCurrentVersion'),
	CREATE_PDF: i18n('i18n.createPDF'),
	CREATE_PDF_DOWNLOAD: i18n('i18n.download'),
	CREATE_PDF_SHARE_LINK: i18n('i18n.createLink'),
	DELETE: i18n('i18n.deleteAsset'),
	DOWNLOAD: i18n('i18n.download'),
	LOCK: i18n('i18n.lockAsset'),
	MENU: i18n('i18n.share'),
	SHARE_LINK: i18n('i18n.createLink'),
	SHARE_EMBED_LINK: i18n('i18n.createEmbed'),
	SHARE_PUBLISH: i18n('i18n.publish'),
	REIMPORT: i18n('i18n.reimport'),
	RESYNC: i18n('i18n.resync'),
	ROUTE: i18n('i18n.route'),
	UNLOCK: i18n('i18n.unlockAsset'),

	MAKE_VISIBLE: i18n('i18n.makeVisible'),
	MAKE_NOT_VISIBLE: i18n('i18n.makeNotVisible'),
}));

export const AssetFileFormatFamilyLabel = Locales((i18n) => ({
	'3d': i18n('i18n.3d'),
	audio: i18n('i18n.audio'),
	animation: i18n('i18n.animation'),
	cameraRaw: i18n('i18n.cameraRaw'),
	compression: i18n('i18n.compression'),
	data: i18n('i18n.data'),
	disk: i18n('i18n.disk'),
	document: i18n('i18n.document'),
	font: i18n('i18n.font'),
	image: i18n('i18n.image'),
	layout: i18n('i18n.layout'),
	presentation: i18n('i18n.presentation'),
	spreadsheet: i18n('i18n.spreadsheet'),
	vector: i18n('i18n.vector'),
	video: i18n('i18n.video'),
}));
